module.exports = __webpack_public_path__ + "static/media/logo2.89213e57.png";